import axios from 'axios'

export const useCommon = () => {
  const isWebView = (ua) => {
    if (!ua) {
      ua = navigator.userAgent
    }
    if (ua.includes('weathernews')) {
      return true
    } else {
      return false
    }
  }

  const isMobileView = () => {
    const windowWidth = window.innerWidth
    return windowWidth < 830
  }

  const cachedAxiosGet = (url, cacheAge = 60) => {
    if (!cachedAxiosGet.cache) cachedAxiosGet.cache = {}

    if (!cachedAxiosGet.cache[url] || Date.now() - cachedAxiosGet.cache[url].last > cacheAge) {
      cachedAxiosGet.cache[url] = {
        data: axios.get(url),
        last: Date.now()
      }
    }

    return cachedAxiosGet.cache[url].data
  }
  return { isWebView, isMobileView, cachedAxiosGet }
}
